import type { Branding } from '@/interfaces/Branding.interface';
import { RosaCoreApiService } from '@/rosa';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoBrandingProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    getBranding$(rootUri: string): Observable<Branding> {
        return this._rosaCoreApiService.checkedGet(`/api/brandings/{rootUri}`, { path: { rootUri } }, true);
    }
}
